$(function() {

  var resize_viewport = function(hasFrame) {
     var the_clickable_container = document.querySelectorAll('.t4s-carousel__nav-item .t4s-carousel__nav-inner');
      var viewport_set = document.querySelectorAll('.flickityt4s-viewport');
      var viewport_rect = viewport_set[0];
      
      var artwork_image_set = document.querySelectorAll('.t4s-product__media-item img');
      var artwork_image = artwork_image_set[artwork_image_set.length-1];

      // this would be better using the flickity api
      the_clickable_container[the_clickable_container.length - 1].click();
      
      var rect = viewport_rect.getBoundingClientRect();
      /*
      console.log("viewport height is: " + rect.height);
      console.log(rect);
      console.log(viewport_rect);
      console.log("measuring artwork: " + artwork_image.currentSrc);
      */
      const test_image = new Image();
      test_image.src = artwork_image.currentSrc;
      /*
      console.log("artwork_image height: " + artwork_image.height);  
      console.log("test_image height: " + test_image.height);  
      */
      if ( hasFrame ) {      
        viewport_rect.style.overflow='visible';
        viewport_rect.style.setProperty('height', artwork_image.height + 220 + 'px');
      }else{
        viewport_rect.style.overflow='hidden';
        viewport_rect.style.setProperty('height', '650px');
      }
      //console.log('lets switch frames');
  }
  
  var update_featured_product_style = function() {
    var variant_sku_text = $('.t4s-sku-value').text();
    var hasFrame = true;  
    var iscanvas = false;
  
    var oe = $('.sku__value:contains("OE-")').length > 0;
    var x = variant_sku_text.slice(-3);
    
    //var the_clickable_container = document.querySelectorAll('.t4s-product__media-item');
    var frame11 = document.querySelectorAll('.t4s-product__media-item img');
    var frame1 = frame11[frame11.length - 1];

    //console.log("image height is: " + frame1.height);      
    //frame1.style.maxWidth = "620px";

    /*
    var the_clickable_container_array = [...the_clickable_container]; // converts NodeList to Array
    the_clickable_container_array.forEach(clickable_container => {
      clickable_container.classList.remove('is-selected');
    });
    the_clickable_container[the_clickable_container.length - 1].classList.add('is-selected');
    */
    frame1.style.height = 'auto';

    frame1.classList.remove("frameblack");
    frame1.classList.remove("framewhite");
    frame1.classList.remove("framescandi");
    frame1.classList.remove("framegold");

    frame1.classList.remove("frameblackcanvas");
    frame1.classList.remove("framegoldcanvas");
    frame1.classList.remove("framescandicanvas");
    frame1.classList.remove("framewhitecanvas");
  
    frame1.classList.remove("noframe");

    if (x == "P-B" || x == "R-B" || x == "M-B") {

        if (oe == true) {
            frame1.classList.add("frameblack");
        } else {
            frame1.classList.add("frameblack");
        }

    } else if (x == "C-B") {

        frame1.classList.add("frameblackcanvas"); iscanvas = true;

    } else if (x == "C-W") {

        frame1.classList.add("framewhitecanvas"); iscanvas = true;

    } else if (x == "C-S") {

        frame1.classList.add("framescandicanvas"); iscanvas = true;

    } else if (x == "C-G") {

        frame1.classList.add("framegoldcanvas"); iscanvas = true;

    } else if (x == "P-W" || x == "R-W" || x == "M-W" || x == "C-W") {

        if (oe == true) {
            frame1.classList.add("framewhite");
        } else {
            frame1.classList.add("framewhite");
        }

    } else if (x == "P-S" || x == "R-S" || x == "M-S" || x == "C-S") {

        if (oe == true) {
            frame1.classList.add("framescandi");
        } else {
            frame1.classList.add("framescandi");
        }

    } else if (x == "P-G" || x == "R-G" || x == "M-G" || x == "C-G") {

        frame1.classList.add("framegold");

    } else if (x == "P-N" || x == "R-N" || x == "C-N" || x == "M-N") {


    } else if (x == "-SS") {

        frame1.classList.add("framesilver");

    } else if (x == "-GS") {

        frame1.classList.add("framegold");

    } else if (x == "-BW") {

        frame1.classList.add("frameblack");

    } else {

        frame1.classList.add("noframe");
        hasFrame = false;
    }

    resize_viewport(hasFrame);
       
    }

    // The timeout is needed to hold the function call back on the event stack so that the browser 
    // can update the SKU text - there should be a variant:change event that passes the SKU in  but it doesnt seem to fire
    $(".is-t4s-name__frame .t4s-swatch__item, .is-t4s-name__materials .t4s-swatch__item").on("click", function() { 

     
      setTimeout(() => update_featured_product_style(), 0);
      //t4s-carousel__nav-item
      
      //if (current_image.height > 600) 
      //  current_image.style.maxWidth = "620px";
      //else
      //  current_image.style.maxWidth = "auto";  
    });

  //t4s-swatch__option is-t4s-name__materials

});